import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SlopedRectangleDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'sloped-rectangle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => {
	if (isCutout) {
		return store.getters.isShapeValid(isCutout) && store.getters.isCutoutGroupValid;
	}

	return store.getters.isShapeValid() && store.getters.isGroupValid;
});

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

const heightLeft = computed({
	get: () => dimensions.value.height_left,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height_left",
			value: value,
		});
	},
});

const heightRight = computed({
	get: () => dimensions.value.height_right,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height_right",
			value: value,
		});
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "sloped-rectangle-width",
        id: `${_ctx.prefix}measurements-sloped-rectangle-width`,
        name: `${_ctx.prefix}measurements[dimensions][width]`,
        unit: "cm",
        label: dimensionLabel.value('width', 'sloped-rectangle'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}sloped-rectangle-width`),
        onBlur: () => _unref(addSizeToDataLayer)('width', +width.value, 'sloped-rectangle'),
        modelValue: width.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((width).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "sloped-rectangle-height_left",
        id: `${_ctx.prefix}measurements-sloped-rectangle-height_left`,
        name: `${_ctx.prefix}measurements[dimensions][height_left]`,
        unit: "cm",
        label: dimensionLabel.value('height_left', 'sloped-rectangle'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('height_left'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}sloped-rectangle-height_left`),
        onBlur: 
				() => _unref(addSizeToDataLayer)('height_left', +heightLeft.value, 'sloped-rectangle')
			,
        modelValue: heightLeft.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((heightLeft).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "sloped-rectangle-height_right",
        id: `${_ctx.prefix}measurements-sloped-rectangle-height_right`,
        name: `${_ctx.prefix}measurements[dimensions][height_right]`,
        unit: "cm",
        label: dimensionLabel.value('height_right', 'sloped-rectangle'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('height_right'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}sloped-rectangle-height_right`),
        onBlur: 
				() => _unref(addSizeToDataLayer)('height_right', +heightRight.value, 'sloped-rectangle')
			,
        modelValue: heightRight.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((heightRight).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"])
    ]),
    _: 1
  }))
}
}

})